import React, { useState } from 'react'

export default function CTAButton() {
    const [isHovered, setIsHovered] = useState(false);


    return (
        <div className='transition-all ease-in-out hover:scale-105'>
            <a href="https://app.senangpay.my/payment/174953854759" target='_blank' rel='noreferrer'>
                <button className="w-full h-full aspect-square rounded-full animate-spin"
                    style={{
                        animationDuration: "4s",
                        animationPlayState: isHovered ? "paused" : "running",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img className='select-none' src="/assets/icon/cta-button.svg" alt="" />
                </button>
            </a>
        </div>
    )
}
